import { render, staticRenderFns } from "./GlobalNavigation.vue?vue&type=template&id=4452b288&"
import script from "./GlobalNavigation.vue?vue&type=script&lang=js&"
export * from "./GlobalNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports